// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../reason/clients/components/Labels.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql = require("../../__generated__/OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.bs.js");

var convertFragment = OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnForSalePropertyStatusLabel$WithoutErrorBoundary(props) {
  var match = use(props.forSaleProperty);
  var status = match.status;
  var isArchived;
  switch (status.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
        isArchived = false;
        break;
    default:
      isArchived = status.archived;
  }
  if (isArchived) {
    return JsxRuntime.jsx(Labels.ArchivedLabel.make, {});
  }
  switch (status.__typename) {
    case "ActiveProperty" :
        if (!status.isRenewable) {
          return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
        }
        var daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
        return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
                    expiringIn: Labels.stringOfExpiring(daysLeft)
                  });
    case "ExpiredProperty" :
        return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "SoldProperty" :
        return JsxRuntime.jsx(Labels.SoldLabel.make, {});
    case "UnderContractProperty" :
        return JsxRuntime.jsx(Labels.UnderContractLabel.make, {});
    case "WithdrawnProperty" :
        return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
        return null;
    
  }
}

var WithoutErrorBoundary = {
  make: OwnForSalePropertyStatusLabel$WithoutErrorBoundary
};

function OwnForSalePropertyStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property status",
              children: JsxRuntime.jsx(OwnForSalePropertyStatusLabel$WithoutErrorBoundary, {
                    forSaleProperty: props.forSaleProperty
                  })
            });
}

var make = OwnForSalePropertyStatusLabel;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
